import React from 'react';
import {getStepLabel} from '../../actions/join/joinActions';
import {translate} from '../../i18n/translate.js';

class JoinWizardSteps extends React.Component {
    getLabel = (step) => {
        if (this.props.hideLabel)
            return "";
        return getStepLabel(step, this.props.staticData.pickupSiteLabel, this.props.isWaitListOnly, this.props.isGuestUser, this.props.staticData.joinSharesStepLabel)
    };

    getStepIndex = (step) => {
        if(step) {
            return this.props.steps.indexOf(step);
        }
    };

    render() {
        const activeStepIndex = this.getStepIndex(this.props.step);
        return (
            <div className="join-steps">
                <ul className="progress-indicator" id="progressIndicator">
                    {this.props.steps.map((step) => {
                        const classOfDoneStep = this.getStepIndex(step) < activeStepIndex ? 'done' : '';
                        return (
                        <li key={step} className={this.props.step===step? 'completed' : classOfDoneStep}> <span className="bubble"/>{translate(this.getLabel(step))}</li>
                        )})}
                </ul>
            </div>
        );
    }
}

export default JoinWizardSteps;



// WEBPACK FOOTER //
// ./src/components/join/JoinWizardSteps.js